import React from "react";
import { Link } from "react-router-dom";
export default function Menu() {
  return (
    <ul className="main-menu__list">
      <li className="megamenu">
        <Link to="/">Home</Link>
      </li>
      <li>
        <Link to="/about">About</Link>
      </li>
      <li>
        <Link to="/shop">Shop</Link>
      </li>
      <li>
        <Link to="/contact">Contact</Link>
      </li>
    </ul>
  );
}
